export default "__VITE_ASSET__e685ec99__"